var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostPurchasedNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.5H7.31568C9.25831 5.5 11.0251 6.6252 11.8466 8.38557L17.5 20.5L19.5 24.5M19.5 24.5H30M19.5 24.5H18.25C15.6266 24.5 13.5 26.6266 13.5 29.25V29.25C13.5 31.8734 15.6266 34 18.25 34H40",
    stroke: "#00AFF0",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 12L37 18.5L47.5 5",
    stroke: "#00AFF0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 44,
    r: 4.5,
    fill: "#00AFF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 44,
    r: 4.5,
    fill: "#00AFF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostPurchasedNotification);
export default __webpack_public_path__ + "static/media/PostPurchasedNotification.32c41186c51cd36bd80193d8967540d8.svg";
export { ForwardRef as ReactComponent };